import { atom } from 'jotai'

import { type ShipmentOrderInfo } from '@/features/vehicle-dispatch-boards'

/**
 * 配車板の配送依頼の編集で表示する配送依頼情報
 */
export const vehicleDispatchBoardsShipmentOrderUpdateAtom =
  atom<ShipmentOrderInfo | null>(null)

vehicleDispatchBoardsShipmentOrderUpdateAtom.debugLabel =
  'vehicleDispatchBoardsShipmentOrderUpdateAtom'
